import apiClient from "./client";

export const getAdminMetalFrames = async (params) => {
  const response = await apiClient.get("/metal-frames/admin", params ? { params } : {});
  return response.data;
};

/** Full metal-frame admin row (`pdfDocuments`, etc.). List endpoint may omit PDF fields. */
export const getAdminMetalFrameById = async (id) => {
  const response = await apiClient.get(`/metal-frames/admin/${id}`);
  return response.data;
};

export const createAdminMetalFrame = async (payload) => {
  const response = await apiClient.post("/metal-frames/admin", payload);
  return response.data;
};

export const updateAdminMetalFrame = async ({ id, payload }) => {
  const response = await apiClient.put(`/metal-frames/admin/${id}`, payload);
  return response.data;
};

export const deleteAdminMetalFrame = async ({ id }) => {
  await apiClient.delete(`/metal-frames/admin/${id}`);
};

export const uploadAdminMetalFrameImage = async ({ id, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/metal-frames/admin/${id}/image`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const removeAdminMetalFrameImage = async ({ id }) => {
  const response = await apiClient.delete(`/metal-frames/admin/${id}/image`);
  return response.data;
};

const assertPdfFile = (file) => {
  if (!file) {
    throw new Error("Please select a PDF file.");
  }
  const byMime = String(file.type || "").toLowerCase() === "application/pdf";
  const byName = /\.pdf$/i.test(String(file.name || ""));
  if (!byMime && !byName) {
    throw new Error("Only PDF files are allowed.");
  }
};

export const createAdminMetalFramePdf = async ({ id, title, productSlug }) => {
  const body = { title: String(title || "").trim() };
  const slug = String(productSlug ?? "").trim();
  if (slug) body.productSlug = slug;
  const response = await apiClient.post(`/metal-frames/admin/${id}/pdfs`, body);
  return response.data;
};

export const updateAdminMetalFramePdf = async ({ id, pdfId, payload }) => {
  const response = await apiClient.put(`/metal-frames/admin/${id}/pdfs/${pdfId}`, payload);
  return response.data;
};

export const uploadAdminMetalFramePdfFile = async ({ id, pdfId, file }) => {
  assertPdfFile(file);
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/metal-frames/admin/${id}/pdfs/${pdfId}/file`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteAdminMetalFramePdf = async ({ id, pdfId }) => {
  const response = await apiClient.delete(`/metal-frames/admin/${id}/pdfs/${pdfId}`);
  return response.data;
};

export const clearAdminMetalFramePdfFile = async ({ id, pdfId }) => {
  const response = await apiClient.delete(`/metal-frames/admin/${id}/pdfs/${pdfId}/file`);
  return response.data;
};
